import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { IMAGES, MONTREZ_NOUS } from "./content";
import { useInView } from "./useInView";

const Poster = () => (
  <Dialog>
    <DialogTrigger asChild>
      <button type="button" data-testid="lettre-poster-btn" className="group block w-full text-left md:sticky md:top-24 self-start">
        <div className="overflow-hidden bg-mm-sand">
          <img src={IMAGES.lettre} alt="Affiche de la lettre à celles et ceux qui veulent présider la France" className="w-full h-auto group-hover:scale-[1.03] transition-transform duration-700" loading="lazy" />
        </div>
        <span className="mm-lab text-mm-golddark mt-3 block">L'affiche de la lettre · agrandir</span>
      </button>
    </DialogTrigger>
    <DialogContent className="max-w-3xl p-2 bg-mm-paper rounded-none max-h-[92vh] overflow-y-auto" data-testid="lettre-poster-dialog">
      <DialogTitle className="sr-only">Affiche de la lettre</DialogTitle>
      <img src={IMAGES.lettre} alt="Affiche de la lettre en grand format" className="w-full h-auto" />
    </DialogContent>
  </Dialog>
);

export const Lettre = () => {
  const [ref, cls] = useInView(0.05);
  return (
    <section id="lettre" ref={ref} className={`bg-mm-paper text-mm-ink py-24 md:py-32 border-t border-mm-ink/10 ${cls}`} data-testid="lettre-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr] lg:grid-cols-[160px_1fr_320px] gap-12">
        <p className="mm-lab text-mm-golddark">La lettre</p>
        <article className="reveal min-w-0 mm-body max-w-[62ch] space-y-4">
          <h2 className="disp mm-h2 mb-8">Lettre à celles et ceux qui veulent présider la France</h2>
          <p>Madame, Monsieur,</p>
          <p>La jeunesse est là. Elle vous regarde, elle questionne, elle s'exprime dans la rue, et demain, elle votera. Après-demain, elle héritera de ce que nous lui aurons laissé.</p>
          <p>Alors je vais être simple et direct. Vous voulez prendre la responsabilité suprême de ce beau pays ?</p>
          <p className="disp text-2xl">Débrouillez-vous. Trouvez la solution.</p>
          <p>C'est pour cela que vous vous présentez.</p>
          <p>Mais cette fois, peut-être faudrait-il commencer autrement.</p>
          <p className="disp text-2xl">Pas de promesses vaines.</p>
          <p>Donnez un plan. Un plan comptable. Une photographie de la France à ce jour, et une transcription pour une France à venir.</p>
          <p className="disp text-2xl text-mm-red pt-4">Montrez-nous :</p>
          <ul className="grid sm:grid-cols-2 gap-x-8 border-t border-mm-ink/20">
            {MONTREZ_NOUS.map((m, i) => (
              <li key={m} className="py-2 border-b border-mm-ink/20 flex gap-3"><span className="tab text-mm-golddark font-bold w-6 shrink-0">{String(i + 1).padStart(2, "0")}</span>{m}</li>
            ))}
          </ul>
          <p className="disp text-2xl pt-4">La machine est là.</p>
          <p>Elle permet aujourd'hui de réunir, comparer, calculer, expliquer. Utilisez-la. Pour comprendre. Pour décider. Pour transmettre.</p>
          <p className="disp text-2xl pt-4">La Grande Question</p>
          <p>Comment allez-vous faire ? Avec quelles règles ? Avec quels moyens ? Avec quel calendrier ? Avec quels contrôles ? Et quel bilan accepterez-vous de présenter à la fin de votre mandat ?</p>
          <p className="font-bold">Peut-être que la réponse est déjà dans la question.</p>
          <p>Je ne vous demande pas un discours.<br />Je ne vous demande pas un rêve.<br />Je vous demande un plan.</p>
          <p className="disp text-2xl text-mm-red pt-4">C'est à vous que je pose la Grande Question.</p>
          <p>Et demain, ce seront les enfants qui vous la poseront.</p>
          <p className="italic pt-6 border-t border-mm-ink/20">Un Terrien de 77 ans,<br />qui continue à poser des questions.<br />Et qui fait confiance à ceux qui viendront après.</p>
        </article>
        <div className="md:col-start-2 lg:col-start-auto"><Poster /></div>
      </div>
    </section>
  );
};
